import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, filter, retry, switchMap, throwError } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { debounceTime, take } from 'rxjs/operators';

import { ConnectivityMonitorService } from '../services/connectivity-monitor.service';

export const connectivityInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {
  const connectivityMonitor = inject(ConnectivityMonitorService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0 && !connectivityMonitor.isConnected) {
        return toObservable(connectivityMonitor.connectionStatus).pipe(
          filter((isConnected) => isConnected),
          debounceTime(300),
          take(1),
          switchMap(() => next(req)),
          retry(1),
        );
      }

      return throwError(() => error);
    }),
  );
};
